module.exports = __webpack_public_path__ + "media/images/vp/icon.leftarrow2.red-ce8e7d0804ef30a8b1b6efbaca426c15.svg";